import { DateString } from './date_string';

export enum AcceptedByCode {
  MyPage = 1,
  AutoAccept = 2,
  ACE = 3,
}

export interface LoanApplicationSummary {
  LoanApplicationID: string;
  NumRegisteredBanks: number;
  NumRegisteredLoanRequests: number;
  NumAnsweredLoanRequests: number;
  NumApprovedQuotes: number;
  NumCalls: number;
  NumAnsweredCalls: number;
  NumNotAnsweredCalls: number;
  IsCreatedByTelemarketing: boolean;
  LastAcceptedOfferAt?: DateString;
  LastAcceptedAmount?: number;
  FirstAcceptedOfferAt?: DateString;
  LastAcceptByCode?: AcceptedByCode;
  LastAcceptedLenderID?: string;
  LastApprovedOfferAt?: DateString;
  LastApprovedAmount?: number;
  FirstApprovedOfferAt?: DateString;
  LastLoanRequestAmount?: number;
  LastCallAt?: DateString;
  HighestApprovedAmount?: number;
  LastCancelledQuoteAt?: DateString;
  LastDisbursedQuoteAt?: DateString;
  LastMyPageLoginAt?: DateString;
  LastCompletedStep?: number;
  LastSuccessfulAuthAttempt?: DateString;
  NeedsFollowupAt?: DateString;
  /** The customer's requested follow-up (book-a-call) time, if any. */
  UserRequestedFollowupAt?: DateString;
  FollowupComment?: string;
  CampaignContent?: string;
  CampaignName?: string;
  CampaignMedium?: string;
  LastUpdateAt?: DateString;
  CreatedAt: DateString;
  UpdatedAt: DateString;
}
